export function buildCornerTimeWindows(
  lapStartMs: number,
  lapEndMs: number,
  apexTimesMs: number[],
): Array<{ startMs: number; endMs: number; apexMs: number }> {
  if (apexTimesMs.length === 0) {
    return [];
  }

  return apexTimesMs.map((apexMs, index) => {
    const previousApexMs = index === 0 ? lapStartMs : apexTimesMs[index - 1]!;
    const nextApexMs = index === apexTimesMs.length - 1 ? lapEndMs : apexTimesMs[index + 1]!;
    const startMs = index === 0 ? lapStartMs : Math.round((previousApexMs + apexMs) / 2);
    const endMs =
      index === apexTimesMs.length - 1 ? lapEndMs : Math.round((apexMs + nextApexMs) / 2);

    return { startMs, endMs, apexMs };
  });
}
